import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import StudyMaterialContent from "./components/StudyMaterialContent"

function StudyMaterial(){
    
    return <div>
        <Header/>
        <StudyMaterialContent/>
        <Footer/>
    </div>
}
export default StudyMaterial;